import { ReportsConstants } from '../constants';
import { reportsService } from '../../services/';


export const ReportsActions = {
    fetchCounsellorReports,
    fetchCorporateReports,
	resetReports
};

function fetchCounsellorReports(startDate, endDate, projects, counsellors) {
	return (dispatch) => {
		dispatch({type:ReportsConstants.GETCOUNSELLOR_REPORT});

		reportsService.fetchCounsellorReport(startDate, endDate, projects, counsellors).then(
			(data) => {
				dispatch({type:ReportsConstants.COUNSELLOR_REPORT_SUCCESS,data});
			},
			(error) => dispatch({type:ReportsConstants.COUNSELLOR_REPORT_FAILURE,error})
		);
	};
}


function fetchCorporateReports(startDate, endDate, projects) {
	return (dispatch) => {
		dispatch({type:ReportsConstants.GETCORPORATE_REPORT});

		reportsService.fetchCorporateReport(startDate, endDate, projects).then(
			(data) => {
				dispatch({type:ReportsConstants.CORPORATE_REPORT_SUCCESS,data});
			},
			(error) => dispatch({type:ReportsConstants.CORPORATE_REPORT_FAILURE, error})
		);
	};
}

function resetReports (){
	return (dispatch) => {
		dispatch({type: ReportsConstants.RESET_REPORTS})
	}
}


// WEBPACK FOOTER //
// ./src/store/actions/reports.actions.js